import api from '@/services/api'

export default {
  /**
   * Get public active news
   * @return {Array} news
   */
  async getAll () {
    try {
      const res = await api.get('/news')
      return res.data
    } catch (error) {
      throw `News api service ${error}`
    }
  },


  /**
   * Create news
   * @param {Object} {title: String, description: String, url: String, isActive: Boolean}
   * @return {Number} id
   */
  async create (news) {
    try {
      const res = await api.post('/news', news)
      return res.data
    } catch (error) {
      throw `News api service ${error}`
    }
  },

  /**
   * Update news
   * @param {Object} news 
   */
  async update (news) {
    try {
      const res = await api.put('/news/' + news.id, news)
      return res.data
    } catch (error) {
      throw `News api service ${error}`
    }
  },

  /**
   * Update news image
   * @param {Number} id
   * @param {File} image
   * @return {String} image name
   */
  async updateImage (id, image) {
    try {
      let formData = new FormData()
      formData.append('file', image)
      const res = await api.post('/news/' + id + '/image', formData)
      return res.data
    } catch (error) {
      throw `News api service ${error}`
    }
  },

  /**
   * Delete one news by id
   * @param {Number} id
   */
  async delete (id) {
    try {
      const res = await api.delete('/news/' + id)
      return res.data
    } catch (error) {
      throw `News api service ${error}`
    }
  }
}